<app-ui-main-menu>
  <router-outlet></router-outlet>
</app-ui-main-menu>
